import {LatinDigitsValidator, WhitespaceValidator} from '@spa/validators';

import * as moment from 'moment';

import {Validators} from '@angular/forms';

import {ComponentTypesEnum} from '../../../../app/shared/enums/common';
import {BaseControl, DatepickerControl} from '../../../../app/shared/classes/controls';

export const CompanyVatDetailsLeiCodeSelector = 'leiCode';
export const CompanyVatDetailsLeiExpirationDateSelector = 'leiCodeExpirationDate';
export const CompanyVatDetailsVatSelector = 'vatNumber';
export const CompanyVatDetailsGiinSelector = 'giinCode';

export const CompanyVatDetailsLeiCodeLength = 20;

export const CompanyVatDetailsControls = (): BaseControl[] => {
    return [
        new BaseControl({
            name: CompanyVatDetailsLeiCodeSelector,
            value: '',
            placeholder: 'LEI Code',
            validators: [
                Validators.minLength(CompanyVatDetailsLeiCodeLength),
                Validators.maxLength(CompanyVatDetailsLeiCodeLength),
                WhitespaceValidator(),
                LatinDigitsValidator(false)
            ],
            componentType: ComponentTypesEnum.Text,
            upperCaseValue: true,
            floatingLabelNever: true
        }),
        new DatepickerControl({
            name: CompanyVatDetailsLeiExpirationDateSelector,
            value: '',
            placeholder: 'LEI Expiration Date',
            validators: [Validators.required],
            componentType: ComponentTypesEnum.Datepicker,
            minDate: moment().format('YYYY-MM-DD'),
            floatingLabelNever: true
        }),
        new BaseControl({
            name: CompanyVatDetailsVatSelector,
            value: '',
            placeholder: 'VAT',
            validators: [LatinDigitsValidator()],
            componentType: ComponentTypesEnum.Text,
            floatingLabelNever: true
        }),
        new BaseControl({
            name: CompanyVatDetailsGiinSelector,
            value: '',
            placeholder: 'GIIN',
            validators: [LatinDigitsValidator()],
            componentType: ComponentTypesEnum.Text,
            floatingLabelNever: true
        })
    ];
};
